import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { SelectMultiItemsDialogData } from '@components/select-multi-items-dialog/1.0/index';
import { ButtonStyle } from '@constants/button/1.0';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ItemListComponent } from '../../item-list/1.0/item-list.component';
import { ButtonComponent } from '../../button/1.0/button.component';

@Component({
  selector: 'txp-select-multi-items-dialog',
  templateUrl: './select-multi-items-dialog.component.html',
  styleUrls: ['./select-multi-items-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    ItemListComponent,
    MatDialogActions,
    ButtonComponent,
  ],
})
export class SelectMultiItemsDialogComponent {
  buttonStyle = ButtonStyle;
  disableContinueBtn: boolean;
  stagedSelectedItems: any[];
  constructor(
    private dialogRef: MatDialogRef<SelectMultiItemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectMultiItemsDialogData,
  ) {
    this.stagedSelectedItems = data.itemsList;
    this.disableContinueBtn = this.stagedSelectedItems.length === 0 ? true : false;
  }

  handleContinue() {
    if (this.stagedSelectedItems) {
      return this.dialogRef.close(this.stagedSelectedItems);
    }
  }

  onSelected(selected: any[]) {
    this.stagedSelectedItems = selected;
    this.disableContinueBtn = this.stagedSelectedItems.length === 0 ? true : false;
  }

  handleCancel() {
    this.dialogRef.close();
  }
}
